import { unionWith, isEqual } from "lodash";
import * as types from "../actionTypes.js";

export const marginPool = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    case types.MARGIN_POOL_DATA_LOADED:
      return { ...state, loaded: true, data: action.marginData };
    default:
      return state;
  }
};

export const marginAccount = (state = { loaded: false, data: [] }, action) => {
  switch (action.type) {
    case types.MARGIN_ACCOUNT_DATA_LOADED:
      return { ...state, loaded: true, data: action.marginAccountData };
    default:
      return state;
  }
};

export const marginEvents = (state = { loaded: false }, action) => {
  switch (action.type) {
    case types.MARGIN_EVENTS_LOADED:
      return {
        ...state,
        loaded: true,
        lendEvents: action.lendEvents,
        redeemEvents: action.redeemEvents,
        borrowEvents: action.borrowEvents,
        repaidEvents: action.repaidEvents
      };
    case types.LEND_EVENT_ADDED:
      return { ...state, lendEvents: unionWith(state.lendEvents, [action.lendEvent], isEqual) };
    case types.REDEEM_EVENT_ADDED:
      return { ...state, redeemEvents: unionWith(state.redeemEvents, [action.redeemEvent], isEqual) };
    case types.BORROW_EVENT_ADDED:
      return { ...state, borrowEvents: unionWith(state.borrowEvents, [action.borrowEvent], isEqual) };
    case types.REPAID_EVENT_ADDED:
      return { ...state, repaidEvents: unionWith(state.repaidEvents, [action.repaidEvent], isEqual) };
    default:
      return state;
  }
};
